import { Link } from "react-router-dom";
import "../styles/navbar.css";
import logo from "../assets/logo.png";


export default function Navbar() {
  return (
    <header className="navbar">
      <div className="navbar-inner">
        <img src={logo} alt="Millennials" className="navbar-logo" />

        <nav className="navbar-links">
          <Link to="/">Inicio</Link>
          <Link to="/cursos">Master Class</Link>
          <Link to="/contacto">Contacto</Link>
          <Link to="/nosotros">Nosotros</Link>
        </nav>
      </div>
    </header>
  );
}
